<template>
  <div class="content-actor-box">
    <strong>출연 :</strong>
    <template v-for="(actor, index) in actorList">
      <span :key="index" class="content-actor-list">
        <a href="#" @click.prevent="searchText(actor?.text)">{{
          actor?.text
        }}</a>
      </span>
      <template v-if="index !== actorList.length - 1">, </template>
    </template>
  </div>
</template>

<script setup>
  import { defineProps } from 'vue'
  import { useRouterComposable } from '@/common/use/useRouterComposable'
  import { PATH_NAME_SEARCH } from '@/common/resources/router.const'

  const { pushRouter } = useRouterComposable()
  defineProps({
    actorList: {
      type: Array,
      default: () => [],
    },
  })

  const searchText = (_text) => {
    const text = _text.trim()

    pushRouter({
      name: PATH_NAME_SEARCH,
      query: {
        searchWord: text,
      },
    })
  }
</script>
